export enum FeatureName {
  DAILY_LOGIN = "daily_login",
  PURCHASE_VAS = "purchase_vas",
  RAKING = "ranking",
}
